import { derived } from "svelte/store"
import { notificationData } from "./notifications-data"
import { currentNativeNotifications } from "@utils/cap-notification-manager/cap-notification-manager"
import { acim } from "@utils/acim"
import { LessonClass, WorkbookItemClass } from "@circleofa/acim-engine"

export const notificationsIsCurrentLesson = derived(
    [notificationData, currentNativeNotifications],
    ([notfData, notfLesson]) => {
        if (notfData === null || notfLesson === null) return null
        return notfData.currentLesson === notfLesson.lesson
    },
)

/**
 * Gets the appropriate lesson class for the number, including intro and epilogue
 * @param lesson 0-366
 */
export function numberToLesson(lesson: number): WorkbookItemClass {
    let lessonClass: WorkbookItemClass | null = null
    if (lesson === 366) lessonClass = acim.workbook.specialPages.get("Ep") || null
    if (lesson === 0) lessonClass = acim.workbook.specialPages.get("In") || null
    lessonClass = lessonClass ?? acim.workbook.getLesson(lesson)
    if (lessonClass === null) throw new Error(`Could not find lesson class ${lesson}`)
    return lessonClass
}
